// @workflow assistant.voice
/**
 * Read aloud's codes (contract "Read aloud", errors table). A body that breaks off after the audio
 * started, or audio the browser can't play, is `speech.failed` too. The words are in
 * readAloudMessages.js.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */
import { codeForRefusal } from './refusalCodes.js';

export const READ_ALOUD_CODE = Object.freeze({
  UNAVAILABLE: 'speech.unavailable',
  NOT_FOUND: 'speech.not_found',
  NOTHING_TO_READ: 'speech.nothing_to_read',
  FAILED: 'speech.failed',
});

export const SPEECH_SERVER_CODES = Object.freeze(Object.values(READ_ALOUD_CODE));

const CODE_BY_STATUS = Object.freeze({
  503: READ_ALOUD_CODE.UNAVAILABLE,
  404: READ_ALOUD_CODE.NOT_FOUND,
  422: READ_ALOUD_CODE.NOTHING_TO_READ,
  502: READ_ALOUD_CODE.FAILED,
});

/** A refused speech request → its code. */
export function codeForSpeechRefusal(status, body) {
  return codeForRefusal(status, body, { codes: SPEECH_SERVER_CODES, byStatus: CODE_BY_STATUS, fallback: READ_ALOUD_CODE.FAILED });
}
